module.exports = __webpack_public_path__ + "media/stockholm/subway_pole-b347a833.jpg";